import { useState } from "react";
import "./OnlineBooking.css";
import { FaStripe } from "react-icons/fa";
import {
  ConnectStripeAccount,
  UpdateAcceptOnlinePaymentsOption,
  GetLoginLink,
  DisconnectStripeAccount,
  UpdateCurrency,
  RefreshBalances,
  ConnectStripeAccountAttention
} from './Requests';
import { formatMinor } from "../../Components/Reusable/CurrencyFormatter/CurrencyFormatter";
import CreateIcon from '@mui/icons-material/Create';
import { useNavigate } from 'react-router-dom';
import {
  notifyError,
  notifySuccess
} from '../../Response/ResposeHandler';
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import CustomButton from "../../Components/Reusable/Button/CustomButton";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

const currencies = [
  { value: 0, label: 'GBP' },
  { value: 1, label: 'EUR' }
];

const Payments = (props) => {
  const { t } = useTranslation("payments");
  const navigate = useNavigate();

  const [config, setConfig] = useState(props.config);
  const [paymentServiceDetails, setPaymentServiceDetails] = useState(props.paymentServiceDetails);
  const [connectStripeAccountLoading, setConnectStripeAccountLoading] = useState(false);
  const [status , setStatus] = useState(props.status);
  const [enabledOnlinePaymentsButton, setEnableOnlinePaymentsButtons] = useState(props.config.acceptOnlinePayments);
  const [manageAccountButtonLoading, setManageAccountButtonLoading] = useState(false);
  const [disconnectAccountButtonLoading, setDisconnectAccountButtonLoading] = useState(false);
  const [currency, setCurrency] = useState(currencies.find(x => x.label === props.config.currency));
  const [currencyButtonLoading, setCurrencyButtonLoading] = useState(false);

  function ConnectStripAccountButtonClick() {
    setConnectStripeAccountLoading(true);
    ConnectStripeAccount().then((res) => {
      if (res.status === 200) {
        window.open(res.data);
      }
    }).finally(() => {
      setConnectStripeAccountLoading(false);
    });
  }

  function ConnectStripAccountAttentionButtonClick() {
    setConnectStripeAccountLoading(true);
    ConnectStripeAccountAttention().then((res) => {
      if (res.status === 200) {
        window.open(res.data);
      }
    }).finally(() => {
      setConnectStripeAccountLoading(false);
    });
  }

  function updateAcceptPaymentsOption(e) {
    const checked = e.target.checked;
    UpdateAcceptOnlinePaymentsOption(checked).then((res) => {
      if (res.status === 200 && checked) {
        notifySuccess(t('payments.toasts.onlinePaymentsOn'));
        setEnableOnlinePaymentsButtons(true);
      }
      if (res.status === 200 && !checked) {
        notifySuccess(t('payments.toasts.onlinePaymentsOff'));
        setEnableOnlinePaymentsButtons(false);
      }
    }).catch(() => {
      notifyError(t('payments.toasts.onlinePaymentsToggleError'));
      setEnableOnlinePaymentsButtons(false)
    });
  }

  function SubmitCurrency() {
    setCurrencyButtonLoading(true);
    UpdateCurrency(currency.label).then((res) => {
      if (res.status === 200) {
        notifySuccess(t('payments.toasts.currencySaved'));
      }
    }).catch(() => {
      notifyError(t('payments.toasts.currencySaveError'));
    }).finally(() => {
      setCurrencyButtonLoading(false);
      props.getConfig();
    });
  }

  function ManageStripeAccountClicked() {
    setManageAccountButtonLoading(true);
    GetLoginLink().then((res) => {
      if (res.status === 200) {
        window.open(res.data);
      }
    }).catch(() => {
      // optional toast if you want
    }).finally(() => {
      setManageAccountButtonLoading(false);
    });
  }

  function DisconnectAccountClicked() {
    setDisconnectAccountButtonLoading(true);
    DisconnectStripeAccount().then((res) => {
      if (res.status === 200) {
        props.getConfig();
        notifySuccess(t('payments.toasts.stripeDisconnected'));
        navigate(0);
      }
    }).catch(() => {
      notifyError(t('payments.toasts.stripeDisconnectError'));
    }).finally(() => {
      setDisconnectAccountButtonLoading(false);
    });
  }

  function RefreshBalanceWrapper() {
    RefreshBalances().then((res) => {
      if (res.status === 200) {
        notifySuccess(t('payments.toasts.balanceUpdated'));
      }
    }).catch(() => {
      notifyError(t('payments.toasts.balanceUpdateError'));
    }).finally(() => {
      props.getConfig();
    });
  }

  // status banner text (re-uses same keys everywhere)
  const statusText = (() => {
    if (status === "Connected") return t('payments.status.connectedToStripe');
    if (status === "no payouts") return t('payments.status.payoutsNotSetUp');
    if (status === "no charges") return t('payments.status.chargesNotSetUp');
    return '';
  })();

  return (
    <>
      {/* <ToastContainer /> */}

      {/* Not connected at all */}
      {config.stripeAccountId === null ? (
        <div>
          <div className="payConnect">
            <div className="payConnect__card">
              <div className="payConnect__info">
                <div className="payConnect__badge">{t('payments.badge.payments')}</div>
                <h3 className="payConnect__title">{t('payments.titles.connectStripe')}</h3>
                <p className="payConnect__sub">
                  {t('payments.subtitles.enableOnlinePayments')}
                </p>
              </div>

              <button
                type="button"
                className="payConnect__btn"
                onClick={ConnectStripAccountButtonClick}
                disabled={connectStripeAccountLoading}
              >
                <span className="payConnect__btnIcon" aria-hidden="true">
                  <FaStripe />
                </span>
                {!connectStripeAccountLoading ? (
                  <span>{t('payments.actions.connectStripeAccount')}</span>
                ) : (
                  <span className="app-btn__spinner" />
                )}
              </button>
            </div>
          </div>

          <section className="schedCard mt-4">
            <div className="gen-cardHead">
              <h3 className="gen-h3">{t('payments.titles.currency')}</h3>
              <p className="gen-muted">{t('payments.subtitles.currencyDescription')}</p>
            </div>

            <div className="schedBody">
              <div className="schedSelect">
                <Select
                  isSearchable={false}
                  placeholder={t('payments.placeholders.selectCurrency')}
                  closeMenuOnSelect
                  options={currencies}
                  defaultValue={currencies.find(x => x.label === config.currency)}
                  onChange={(e) => setCurrency({ value: e.value, label: e.label })}
                  classNamePrefix="rs"
                />
              </div>
            </div>

            <div className="infoActions mt-3">
              <CustomButton
                disabled={currencyButtonLoading}
                onClick={SubmitCurrency}
                className="app-btn--sm"
                label={t('payments.actions.save')}
                loading={currencyButtonLoading}
              />
            </div>
          </section>
        </div>
      ) : /* Connected but details not submitted/finished */ !config.detailsSubmitted ? (
        <div>
          <div className="payConnect">
            <div className="payConnect__card">
              <div className="payConnect__info">
                <div className="payConnect__badge">{t('payments.badge.payments')}</div>
                <h3 className="payConnect__title">{t('payments.titles.connectStripe')}</h3>
                <p className="payConnect__sub">
                  {t('payments.subtitles.enableOnlinePayments')}
                </p>
              </div>

              <button
                type="button"
                className="payConnect__btn"
                onClick={ConnectStripAccountButtonClick}
                disabled={connectStripeAccountLoading}
              >
                <span className="payConnect__btnIcon" aria-hidden="true">
                  <FaStripe />
                </span>
                {!connectStripeAccountLoading ? (
                  <span>{t('payments.actions.finishStripeSetup')}</span>
                ) : (
                  <span className="app-btn__spinner" />
                )}
              </button>
            </div>
          </div>

          <section className="schedCard mt-4">
            <header className="schedHead">
              <h3 className="schedTitle">{t('payments.titles.currency')}</h3>
              <p className="schedDesc">{t('payments.subtitles.currencyDescription')}</p>
            </header>
            <div className="schedBody">
              <div className="schedSelect">
                <Select
                  isSearchable={false}
                  placeholder={t('payments.placeholders.selectCurrency')}
                  closeMenuOnSelect
                  options={currencies}
                  defaultValue={currencies.find(x => x.label === config.currency)}
                  onChange={(e) => setCurrency({ value: e.value, label: e.label })}
                  classNamePrefix="rs"
                />
              </div>
            </div>
            <div className="infoActions mt-3">
              <CustomButton
                disabled={currencyButtonLoading}
                onClick={SubmitCurrency}
                className="app-btn--sm"
                label={t('payments.actions.save')}
                loading={currencyButtonLoading}
              />
            </div>
          </section>
        </div>
      ) : /* Connected but requirements need attention */ paymentServiceDetails.requirements ? (
        <div>
          <div className="payConnect">
            <div className="payConnect__card" style={{ backgroundColor: "#ff7d7d" }}>
              <div className="payConnect__info">
                <div className="payConnect__badge">{t('payments.badge.payments')}</div>
                <h3 className="payConnect__title">{t('payments.titles.connectStripe')}</h3>
                <p className="payConnect__sub" style={{ color:"#3c1c1c" }}>
                  {t('payments.subtitles.requirementsAttention')}
                </p>
              </div>

              <button
                type="button"
                className="payConnect__btn"
                style={{ backgroundColor:"#c30000" }}
                onClick={ConnectStripAccountAttentionButtonClick}
                disabled={connectStripeAccountLoading}
              >
                <span className="payConnect__btnIcon" aria-hidden="true">
                  <FaStripe />
                </span>
                {!connectStripeAccountLoading ? (
                  <span>{t('payments.actions.accountRequiresAttention')}</span>
                ) : (
                  <span className="app-btn__spinner" />
                )}
              </button>
            </div>
          </div>

          <section className="schedCard mt-4">
            <header className="schedHead">
              <h3 className="schedTitle">{t('payments.titles.currency')}</h3>
              <p className="schedDesc">{t('payments.subtitles.currencyDescription')}</p>
            </header>
            <div className="schedBody">
              <div className="schedSelect">
                <Select
                  isSearchable={false}
                  placeholder={t('payments.placeholders.selectCurrency')}
                  closeMenuOnSelect
                  options={currencies}
                  defaultValue={currencies.find(x => x.label === config.currency)}
                  onChange={(e) => setCurrency({ value: e.value, label: e.label })}
                  classNamePrefix="rs"
                />
              </div>
            </div>
            <div className="infoActions mt-3">
              <CustomButton
                disabled={currencyButtonLoading}
                onClick={SubmitCurrency}
                className="app-btn--sm"
                label={t('payments.actions.save')}
                loading={currencyButtonLoading}
              />
            </div>
          </section>
        </div>
      ) : (
        // Fully connected dashboard
        <div className="payDash">
          <div className="payDash__head">
            <div className={`payDash__status ${status.toLowerCase().replace(" ", "-")}`}>
              {statusText}
            </div>

            <div className="payDash__titleRow">
              <h1 className="payDash__title">{t('payments.titles.payments')}</h1>

              <div className="payDash__toggle">
                <label className="payDash__toggleLabel">{t('payments.actions.acceptOnlinePayments')}</label>
                <div className="live-switch-wrapper">
                  <input
                    className="toggle-switch"
                    type="checkbox"
                    checked={enabledOnlinePaymentsButton}
                    id="accept-payments"
                    onChange={updateAcceptPaymentsOption}
                  />
                  <label htmlFor="accept-payments" className="switch-label-payments"/>
                </div>
              </div>
            </div>
          </div>

          <div>
            <button
              type="button"
              className="icon-btn"
              onClick={RefreshBalanceWrapper}
              aria-label={t('payments.actions.refreshBalances')}
              title={t('payments.actions.refreshBalances')}
            >
              <CreateIcon fontSize="small" />
            </button>
          </div>

          {/* Funds */}
          <div className="payDash__stats">
            <div className="payDash__statCard">
              <span className="payDash__statLabel">{t('payments.labels.availableFunds')}</span>
              <div className="payDash__statValue">
                {formatMinor(paymentServiceDetails.availableFunds, config.currency)}
              </div>
            </div>
            <div className="payDash__statCard">
              <span className="payDash__statLabel">{t('payments.labels.pendingFunds')}</span>
              <div className="payDash__statValue">
                {formatMinor(paymentServiceDetails.pendingFunds, config.currency)}
              </div>
            </div>
          </div>

          <div className="payDash__divider" />

          {/* Stripe account actions */}
          <section className="payDash__section">
            <h3 className="payDash__h3">{t('payments.titles.stripeAccount')}</h3>
            <div className="payDash__actions">
              <button
                className="payDash__btn payDash__btn--primary"
                onClick={ManageStripeAccountClicked}
                disabled={manageAccountButtonLoading}
              >
                {!manageAccountButtonLoading ? (
                  t('payments.actions.manageAccount')
                ) : (
                  <span className="app-btn__spinner" />
                )}
              </button>

              <button
                className="payDash__btn payDash__btn--danger"
                onClick={DisconnectAccountClicked}
                disabled={disconnectAccountButtonLoading}
              >
                {disconnectAccountButtonLoading ? (
                  <span className="app-btn__spinner" />
                ) : (
                  t('payments.actions.disconnectAccount')
                )}
              </button>
            </div>
          </section>

          <div className="payDash__divider" />

          <header className="schedHead">
            <h3 className="schedTitle">{t('payments.titles.currency')}</h3>
            <p className="schedDesc">{t('payments.subtitles.currencyDescription')}</p>
          </header>

          <div className="schedBody">
            <div className="schedSelect">
              <Select
                isSearchable={false}
                placeholder={t('payments.placeholders.selectCurrency')}
                closeMenuOnSelect
                options={currencies}
                defaultValue={currencies.find(x => x.label === config.currency)}
                onChange={(e) => setCurrency({ value: e.value, label: e.label })}
                classNamePrefix="rs"
              />
            </div>
            <p className="sm-hint" style={{fontSize:"0.9rem"}}>
              {t('payments.subtitles.balancesHint')}
            </p>
          </div>

          <div className="infoActions mt-3">
            <CustomButton
              disabled={currencyButtonLoading}
              onClick={SubmitCurrency}
              className="app-btn--sm"
              label={t('payments.actions.save')}
              loading={currencyButtonLoading}
            />
          </div>

          <div className="payDash__divider" />

          {/* Help */}
          <section className="payDash__help">
            <h3 className="payDash__h3">{t('payments.titles.needHelp')}</h3>
            <ul className="payDash__links">
              <li>
                <a
                  href="https://stripe.com/docs/connect/express-dashboard"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('payments.links.whatIsStripeConnect')}
                </a>
              </li>
              <li>
                <a href="/support">{t('payments.links.contactSupport')}</a>
              </li>
            </ul>
          </section>
        </div>
      )}
    </>
  );
};

export default Payments;
